<div
  class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 w-full"
>
  <div class="flex gap-2 items-center">
    <ng-icon name="heroUserCircle" size="20" class="!block" />
    <h2 class="leading-6 font-semibold">
      {{ 'cockpit.dashboard.consultantCard.title' | transloco }}
    </h2>
  </div>
  <div class="flex gap-3 items-center">
    <img
      [src]="consultantData().image"
      [alt]="consultantData().alt"
      width="839"
      height="839"
      class="size-12 rounded-full"
    />
    <div class="flex flex-col">
      <span class="text-sm font-semibold leading-6">{{ consultantData().name }}</span>
      <span class="text-xs leading-4">{{
        'cockpit.dashboard.consultantCard.role' | transloco
      }}</span>
    </div>
  </div>
  <div class="grid grid-cols-2 gap-3">
    <ui-button
      mode="outlined"
      expand="full"
      size="small"
      class="w-full"
      (click)="onClickCalendar()"
    >
      <ng-icon name="heroCalendar" size="20" class="!block" slot="start" />
      {{ 'cockpit.dashboard.consultantCard.appointment' | transloco }}
    </ui-button>
    <ui-button
      *isNotDemoMode="websiteContact"
      mode="outlined"
      expand="full"
      size="small"
      class="w-full"
      (click)="dialog.showModal()"
    >
      <ng-icon name="heroEnvelope" size="20" class="!block" slot="start" />
      {{ 'cockpit.dashboard.consultantCard.contact' | transloco }}
    </ui-button>
    <ng-template #websiteContact>
      <a [href]="links.contact" target="_blank">
        <ui-button mode="outlined" expand="full" size="small" class="w-full">
          <ng-icon name="heroEnvelope" size="20" class="!block" slot="start" />
          {{ 'cockpit.dashboard.consultantCard.contact' | transloco }}
        </ui-button>
      </a>
    </ng-template>
  </div>
</div>

<ui-simple-dialog #dialog>
  <form class="w-full" (submit.prevent)="onSubmit()">
    <ui-simple-dialog-layout (clickCancel)="dialog.close()" class="w-full">
      <h2 slot="title">{{ 'cockpit.dashboard.consultantCard.dialog.title' | transloco }}</h2>

      <div class="flex flex-col gap-4">
        <ui-input-label>
          {{ 'cockpit.dashboard.consultantCard.dialog.subject' | transloco }}
          <span class="text-error dark:text-error-darkmode">*</span>
          <ui-select [formField]="contactForm.subject">
            <option value="" [selected]="contactForm.subject().value() === ''">
              {{ 'cockpit.dashboard.consultantCard.dialog.subjectPleaseSelect' | transloco }}
            </option>
            <option
              [selected]="
                contactForm.subject().value() ===
                ('cockpit.dashboard.consultantCard.dialog.subjectOption1' | transloco)
              "
            >
              {{ 'cockpit.dashboard.consultantCard.dialog.subjectOption1' | transloco }}
            </option>
            <option
              [selected]="
                contactForm.subject().value() ===
                ('cockpit.dashboard.consultantCard.dialog.subjectOption2' | transloco)
              "
            >
              {{ 'cockpit.dashboard.consultantCard.dialog.subjectOption2' | transloco }}
            </option>
            <option
              [selected]="
                contactForm.subject().value() ===
                ('cockpit.dashboard.consultantCard.dialog.subjectOption3' | transloco)
              "
            >
              {{ 'cockpit.dashboard.consultantCard.dialog.subjectOption3' | transloco }}
            </option>
          </ui-select>
          <app-field-errors slot="bottom" [fieldState]="contactForm.subject()" />
        </ui-input-label>

        <ui-input-label>
          {{ 'cockpit.dashboard.consultantCard.dialog.message' | transloco }}
          <span class="text-error dark:text-error-darkmode">*</span>
          <ui-textarea [formField]="contactForm.message" rows="10"></ui-textarea>
          <app-field-errors slot="bottom" [fieldState]="contactForm.message()" />
        </ui-input-label>
      </div>

      <app-http-error [error]="sendContactEmailState().error" slot="error" />

      <div slot="footer" class="flex gap-3 justify-end">
        <ui-button mode="outlined" (click)="dialog.close()" type="button">{{
          'cockpit.dashboard.consultantCard.dialog.cancel' | transloco
        }}</ui-button>
        <ui-button
          type="submit"
          [loading]="sendContactEmailState().isLoading"
          [disabled]="sendContactEmailState().isLoading"
          >{{ 'cockpit.dashboard.consultantCard.dialog.submit' | transloco }}</ui-button
        >
      </div>
    </ui-simple-dialog-layout>
  </form>
</ui-simple-dialog>
